import refs from 'bz-utilities/modules/legacy/refs';
import createReactClass from 'create-react-class';
import _ from 'lodash';
import React from 'react';
import NumericMixin from '../../../../mixins/numeric-mixin';
import ButtonGroup from '../../../form/button-group';
import Button from '../../../general/button';
import Popover from '../../../modal/popover';
import NumPad from '../num-pad';

const Numeric = createReactClass({
  displayName: 'Numeric',
  mixins: [NumericMixin],

  getInitialState: function () {
    return {
      open: false,
      unit: ''
    };
  },

  getDefaultProps: function () {
    return {
      value: 0,
      decimals: 0,
      min: 0
    };
  },

  UNSAFE_componentWillReceiveProps: function (nextProps) {
    if (!_.eq(nextProps, this.props)) this.toDecimal(nextProps.value);
  },

  show: function (e) {
    e.preventDefault();
    this.setState({ open: true, anchorEl: e.currentTarget });
  },

  hide: function () {
    this.setState({ open: false, anchorEl: null });
  },

  onKeyDown: function (e, v) {
    if (e.keyCode === 13) this.hide();
    if (this._refs.numpad.current) this._refs.numpad.current.onKeyDown(e, v);
  },

  onKeyPress: function (e, v) {
    if (this._refs.numpad.current) this._refs.numpad.current.onKeyPress(e, v);
  },

  onUnitChange: function (v) {
    this.setState({ unit: v });
    if (this.props.onUnitChange) this.props.onUnitChange(v);
  },

  onChange: function (v) {
    this.props.onChange(v);
  },

  render: function () {
    var units, label;
    var colSpan = '3';
    var className = '';
    var hasUnits = (this.props.units || []).length > 0;
    var isUnitsArray = Array.isArray(this.props.units);
    var numPadClassName = 'bz-column bz-col-' + (isUnitsArray ? '70' : '100');

    if (this.props.className) className += ' ' + this.props.className;

    if (this.props.readOnly) {
      className += ' numeric-control-readonly';
    }

    if (hasUnits) {
      label = <span className="bz-numeric-label">{this.props.units}</span>;

      if (isUnitsArray) {
        units = (
          <div className="bz-column bz-col-30">
            <div className="bz-scroll">
              <ButtonGroup
                src={this.props.units}
                mode="single"
                display="list"
                value={this.state.unit}
                onChange={this.onUnitChange}
              />
            </div>
          </div>
        );

        label = <span className="bz-numeric-label">{this.props.unit || this.props.valueUnit}</span>;
      }
    }
    return !this.props.readOnly ? (
      <span>
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          className=" bz-numeric"
          onRequestClose={this.hide}
        >
          <div className="bz-row">
            <div className={numPadClassName}>
              <NumPad
                ref={this._refs.numpad}
                value={this.props.value}
                onChange={this.onChange}
                decimals={this.props.decimals}
                colSpan={colSpan}
                min={this.props.min}
                max={this.props.max}
                close={this.hide}
              />
            </div>
            {units}
          </div>
        </Popover>
        <span className="bz-button-group" onKeyPress={this.onKeyPress} onKeyDown={this.onKeyDown}>
          <Button errorText={this.props.errorText} onClick={this.show}>
            <span>{this.props.value}</span>
            {label}
          </Button>
        </span>
      </span>
    ) : (
      <span className={className}>
        <span className="numeric-value">{this.props.value}</span>
        {label}
      </span>
    );
  }
});

export default refs('numpad')(Numeric);
